import { Box } from '@mui/material';
import { ButtonUI, CheckboxUI, DialogUI } from '../../../Interface';
import { useState } from 'react';
import dvTaskResourcePlannerService from '../../../../service/client/delVill/dvtaskResourcePlanner.service';

const GroupDialog = ({ groupDialogData, handleClose, groups, setTaskChanged }) => {
  const { open, task } = groupDialogData;
  const [checkedGroupId, setCheckedGroupId] = useState([]);

  const groupsForMap = groups?.filter((group) => group.value !== task?.resourceFourId);

  const allChecked = groupsForMap.map((group) => group.value);

  const isAllChecked = checkedGroupId.length > 0 && checkedGroupId.length === allChecked.length;

  const onClose = () => {
    setCheckedGroupId([]);
    handleClose();
  };

  const handleSave = () => {
    const body = {
      simpleTaskId: task.simpleTaskId,
      groupIds: checkedGroupId,
    };
    dvTaskResourcePlannerService.copyAndCreateTask(body).then(() => {
      onClose();
      setTaskChanged(true);
    });
  };

  return (
    <DialogUI
      open={open}
      onClose={onClose}
      headerContent="Csoportok"
      sx={{
        '& .MuiDialog-container': { alignItems: 'flex-start' },
        '& .MuiPaper-root': { width: '100%', maxWidth: '800px' },
        '& .MuiDialogContent-root': { overflowY: 'auto', maxHeight: '100%' },
        marginTop: '40px',
      }}
    >
      <Box>
        <CheckboxUI
          label={isAllChecked ? 'Összes kijelölés eltávolítása' : 'Összes kijelölése'}
          checked={isAllChecked}
          onChange={() => setCheckedGroupId(isAllChecked ? [] : allChecked)}
        />
        <Box mt="1rem">
          {groupsForMap.map((group) => (
            <Box key={group.value}>
              <CheckboxUI
                sx={{ m: 0, mb: 0.5, p: 0 }}
                label={group.label}
                checked={checkedGroupId.includes(group.value)}
                onChange={() => {
                  setCheckedGroupId((prev) =>
                    prev.includes(group.value) ? prev.filter((id) => id !== group.value) : [...prev, group.value]
                  );
                }}
              />
            </Box>
          ))}
        </Box>

        <Box display="flex" gap="0.5rem" justifyContent="center">
          <ButtonUI
            text="Mentés"
            className="bg-success"
            onClick={() => handleSave()}
            disabled={!checkedGroupId.length}
          />
          <ButtonUI text="Bezárás" className="bg-primary" onClick={onClose} />
        </Box>
      </Box>
    </DialogUI>
  );
};

export default GroupDialog;
